module.exports = __webpack_public_path__ + "img/square.d5600e9e.svg";